import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import globalMixinKeyword from './mixins/globalMixinsKeyword.js';
import './assets/css/tailwind.css';
const app = createApp(App);
app.mixin(globalMixinKeyword);
app.use(store).use(router).mount('#app');
